/* Anmeldung auf der Landingpage ohne Seitenwechsel.

   Schickt die Adresse an Klaviyos oeffentlichen Client-Endpunkt und
   meldet das Ergebnis direkt auf der Seite zurueck.

   Wichtig fuer die Texte: Klaviyo antwortet mit 202 und leerem Body.
   Die Antwort sagt NICHT, ob eine Double-Opt-in-Mail rausging oder ob
   die Adresse schon auf der Liste stand — das ist Absicht, sonst
   koennte jeder ueber das Formular abfragen, wer eingetragen ist.
   Deshalb gibt es nur eine Erfolgsmeldung, und die muss beide Faelle
   abdecken. Welcher Text erscheint, steuert data-optin (double|single)
   aus den Section-Einstellungen. */
(() => {
  const ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';
  const REVISION = '2026-07-15';

  const setState = (form, state, message) => {
    const box = form.querySelector('[data-signup-status]');
    form.dataset.state = state;
    if (!box) return;
    box.textContent = message || '';
    box.hidden = !message;
    box.classList.toggle('hlp-form__status--error', state === 'error');
    box.classList.toggle('hlp-form__status--success', state === 'success');
  };

  /* Rueckfall auf das normale Formular (action/method stehen im Markup):
     oeffnet Klaviyos Seite in einem neuen Tab, so wie vor dem Umbau. */
  const nativeSubmit = (form) => {
    setState(form, 'idle', '');
    form.dataset.fallback = 'true';
    HTMLFormElement.prototype.submit.call(form);
  };

  const submit = async (form) => {
    const input = form.querySelector('input[type="email"]');
    const button = form.querySelector('button[type="submit"]');
    const company = form.dataset.company;
    const list = form.dataset.list;

    if (!input || !input.value) return;

    /* Ohne Konfiguration waere der Request sinnlos — dann lieber eine
       ehrliche Fehlermeldung als ein falsches "hat geklappt". */
    if (!company || !list) {
      setState(form, 'error', form.dataset.msgError);
      return;
    }

    setState(form, 'loading', '');
    if (button) button.disabled = true;

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: input.value.trim(),
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
              },
            },
          },
        },
        relationships: { list: { data: { type: 'list', id: list } } },
      },
    };

    try {
      const response = await fetch(
        `${ENDPOINT}?company_id=${encodeURIComponent(company)}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            revision: REVISION,
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        /* 202: angenommen. Mehr verraet Klaviyo nicht, siehe oben. */
        const isDouble = form.dataset.optin !== 'single';
        setState(form, 'success', isDouble ? form.dataset.msgDouble : form.dataset.msgSingle);
        form.reset();
      } else if (response.status === 400 || response.status === 422) {
        /* An der Eingabe liegt es: Adresse pruefen lassen. */
        setState(form, 'error', form.dataset.msgError);
      } else {
        /* 403 & Co. heisst Konfiguration, nicht Nutzerfehler — etwa wenn
           die Domain nicht auf Klaviyos Allowlist fuer den Public Key
           steht. Dann lieber klassisch abschicken als die Anmeldung
           verlieren. */
        nativeSubmit(form);
      }
    } catch (error) {
      /* Netzwerk weg oder Request geblockt: ebenfalls klassisch. */
      nativeSubmit(form);
    } finally {
      if (button) button.disabled = false;
    }
  };

  const init = () => {
    document.querySelectorAll('form[data-klaviyo-form]').forEach((form) => {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        submit(form);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
